/** True when the API rejected a mutation because the donation is already paid. */
export function isDonationAlreadyPaidError(error) {
  const status = error?.response?.status;
  const msg = error?.response?.data?.error ?? '';
  return (
    status === 409 ||
    String(msg).toLowerCase().includes('donation already paid')
  );
}
